/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Option/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Option({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/TypeAndDuration/Content/TemplateSelect/Content/Options/Option",
  width = "auto",
  onClick,
  disabled,
  isSelected,
  size
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let templateColorIdComputedValueData = fromData.useDataFormat({ viewPath,
context: 'template',
path: 'color_id_computed',
format: fromFormat.appointmentTypeColor,
})
let templateTextValueData = fromData.useDataValue({ viewPath,
context: 'template',
path: 'text',
})
  return (<React.Fragment
>
<button
  data-testid="Option.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bblr-3-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-4-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-5-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-6-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-7-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-8-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-9-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-10-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-11-Z2h7tiu': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--w-12-Z2h7tiu': typeof width === 'number' ? `${width}px` : width,'--bc-2-Z2h7tiu': isSelected ? dtColorsNeutral200 : isHovered ? dtColorsNeutral200 : dtColorsWhite,'--c-1-Z2h7tiu': disabled ? "default" : "pointer"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Option.Vertical"
  data-view-path={viewPath}
 style={{'--bc-2-Z2h7tiu': templateColorIdComputedValueData,'--h-13-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--w-12-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size={size}
 textOverflow="none"
 overflowX="visible"
 data="template.text"
 text={templateTextValueData}
/>
</button>
{children}
</React.Fragment>)
}